<div *transloco="let t" class="overflow-x-hidden">
  <div class="mb-8">
    <h1 class="text-2xl font-semibold text-primary">{{ t('HEADER.MANAGE_ORDER') }}</h1>
  </div>

  @if (isContentLoading()) {
  <juno-libs-ui-orders-skeleton section="widget" />
  } @else {
  <dss-libs-ui-widget
    (filterByWidgetName)="filterByWidgetName($event)"
    [activeOrders]="activeStatus()"
    [allOrder]="allOrderCount()"
    [closedOrders]="closedStatus()"
    [completedOrders]="completedStatus()"
    [selectedStatus]="widgetStatus()"
  ></dss-libs-ui-widget>
  }

  <!-- Search + button row always visible -->
  <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3 mb-8">
    <dss-libs-ui-search
      (searchValue)="getSearchKeyWord($event)"
      [query]="searchValue()"
      class="grow lg:grow-0 lg:w-112.5"
    ></dss-libs-ui-search>
    <dss-libs-ui-button
      appliedClasses="w-full! lg:w-auto! h-12! lg:h-11!"
      *dssLibsUiAuthorizedRole="UserRole.User"
      [iconMetaData]="createOrderIcon"
      label="HEADER.CREATE_ORDER"
      (clickOutput)="navigateToCreateOrderPage()"
    ></dss-libs-ui-button>
  </div>

  @if (isContentLoading()) {
  <juno-libs-ui-orders-skeleton section="table" />
  } @else if (ordersResource.hasValue()) { @let orders = ordersResource.value().data;
  <div class="relative">
    @if (orders.length) {
    <dss-libs-ui-table
      [columns]="columns"
      [data]="ordersListData()"
      [menuActions]="menuActions"
      [rowKeyFn]="rowKey"
      [isRowClickable]="true"
      [tableStyles]="{ roundedBottom: false }"
      (actionOutput)="handleAction($event)"
      (rowClickOutput)="navigateToOrder($event.id)"
    ></dss-libs-ui-table>
    <dss-libs-ui-paginator
      [totalLength]="totalCount()"
      [loading]="isTableLoading()"
      [(currentPage)]="pageNumber"
      [(pageSize)]="pageSize"
    />
    } @else if (!allOrderCount()?.ordersCount && !searchValue()) {
    <div
      class="flex h-[calc(100dvh-24rem)] lg:h-[calc(100dvh-21rem)] flex-col items-center justify-center gap-6 rounded-lg bg-surface px-4 text-center"
    >
      <div class="flex items-center justify-center rounded-[1.25rem] bg-primary-tint-soft size-16 md:size-24 shrink-0">
        <mat-icon svgIcon="documents-outline" class="size-9! md:size-13! text-primary!"></mat-icon>
      </div>
      <div class="flex flex-col items-center gap-3 max-w-120">
        <p class="text-xl md:text-2xl font-semibold text-ink tracking-[0.24px]">{{ t('NO-ORDERS') }}</p>
        <p class="text-sm md:text-base text-ink-secondary leading-5 md:leading-6 tracking-[0.16px]">
          {{ t('NO-ORDERS-DESCRIPTION') }}
        </p>
      </div>
      <dss-libs-ui-button
        *dssLibsUiAuthorizedRole="UserRole.User"
        color="primary"
        [iconMetaData]="createOrderIcon"
        label="HEADER.CREATE_ORDER"
        (clickOutput)="navigateToCreateOrderPage()"
      ></dss-libs-ui-button>
    </div>
    } @else {
    <dss-libs-ui-no-results class="h-[calc(100dvh-24rem)] lg:h-[calc(100dvh-21rem)]" />
    }
  </div>
  }
</div>
